<template>
  <div>
    <v-row class="justify-start">
      <v-col cols="10" class="pa-0">
        <v-row class="ml-2" justify="start">
          <v-col cols="2" class="py-0">
            <v-select label="Unidad" v-model="uniEje" :items="unidades" dense
              item-text="texto" hide-details item-value="value"></v-select>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-select label="Ambito" v-model="ambito" :items="ambitos" dense
              item-text="texto" hide-details item-value="value"></v-select>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-select label="Coord. Estatal" v-model="coordEst" :items="coordsEst" dense
              item-text="texto" hide-details item-value="value"></v-select>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-select label="Ejercicio" v-model="ejercicio" :items="ejercicios" dense
              item-text="texto" hide-details item-value="value"></v-select>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-select label="Quincena" v-model="quincena" :items="quincenas" dense
              item-text="texto" hide-details item-value="value"></v-select>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-tooltip bottom activator="#btn-reload">
              Actualizar
            </v-tooltip>
            <v-btn id="btn-reload" icon @click="reload"><v-icon>mdi-refresh</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col columns="12" class="py-0 pt-2">
        <v-data-table
          v-model="selected"
          :headers="headerJusti"
          show-select
          :selected="selected"
          :items="justificantes"
          item-key="idJustificante"
          disable-sort
          dense
          :footer-props="footerProps"
          :items-per-page="10"
          :hide-default-footer="hideFooterJusti"
          :loading="loading"
          loading-text="Cargando datos..."
          class="elevation-2"
        >
          <template v-slot:top>

            <v-toolbar flat>
              <div id="findEmp" style="width: 370px;">
                <buscar-empleado class="width-find" :value.sync="empSearch" @click:clear="reload"></buscar-empleado>
              </div>
              <v-spacer></v-spacer>
              <v-tooltip bottom activator="#btn-apli">
                <span>Aplicar</span>
              </v-tooltip>
              <v-btn id="btn-apli" icon @click="validaJustificantes" :disabled="!hasAccesAplicar" dense>
                <v-icon>mdi-check-circle-outline</v-icon>
              </v-btn>
              <v-tooltip bottom activator="#btn-download">
                <span>Descargar</span>
              </v-tooltip>
              <v-btn id="btn-download" icon @click="doDownload()" dense>
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          
          <template v-slot:header.data-table-select="{props}">
            <v-simple-checkbox class="accent black--text" :ripple="false" dense v-model="props.value" 
              :indeterminate="props.indeterminate" @input="onSelectAllJus(props.value)">
            </v-simple-checkbox>
          </template>
          <template v-slot:item.data-table-select="{ item, isSelected, select }">
            <v-simple-checkbox 
              :value="isSelected" 
              @input="select($event)" 
              :ripple="false"
            >
            </v-simple-checkbox>
          </template>
          
          <template v-slot:item.justificante="{ item }">
            <span v-if="haveMotivo(item)"
              @mouseover.capture.stop="showMotivo($event, item.motivo)" @mouseleave.capture.stop="hideMotivo()">
              <v-badge bordered color="pink" icon="mdi-file-document-outline" overlap>
                <v-chip :color="item.color" :text-color="item.fontColor" small @click="editMotivo(item)" >
                  {{ nombreJustificante(item) }}
                </v-chip>
              </v-badge>
            </span>
            <v-chip v-else :color="item.color" :text-color="item.fontColor" small>
              {{ nombreJustificante(item) }}
            </v-chip>
          </template>
          <template v-slot:item.vigenciaIni="{ item }">
            {{ makePeriodo(item) }}
          </template>
          <template v-slot:item.dias="{ item }">
            {{ formatDias(item) }}
          </template>
          <template v-slot:item.diasRecuperados="{ item }">
            {{ item.tipoJustificante === 29? item.diasRecuperados: '-' }}
          </template>
          <template v-slot:item.estatus="{ item }">
            <v-chip :color="item.colorEstatus" :text-color="item.fontColorEstatus" small>
              {{ item.estatus }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu left min-width="150">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
              </template>
              <v-list dense>
                <v-list-item @click="loadMovimientosJusti(item)">
                  <v-list-item-content>
                    <v-list-item-title>Movimientos justificante</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <movs-justi :show.sync="showMovs" :nombre="empledoJustificante" :tipoJustificante="tipoJus" :movs="movsJusti"></movs-justi>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <dialog-message :show.sync="showDlg" :color="colorDlg" :title="titleDlg">
      {{ mensaje }}
    </dialog-message>

    <v-dialog v-model="showDlgMotivo" persistent max-width="600">
      <v-card>
        <v-card-text class="pt-6">
          <v-textarea v-model="motivo" :label="labelMotivo" outlined rows="4" 
            dense :rules="rulesMotivo">
          </v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn v-if="showBtnSave" small text color="primary" :disabled="disabledOkMotivo" @click="saveUpdateJustificante">
            Guardar
          </v-btn>
          <v-btn small text color="primary" @click="showDlgMotivo= false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDlgDownload" persistent max-width="400">
      <v-card>
        <v-card-text class="pt-6">
          <span class="text-subtitle-1 font-weight-medium">Descargar solo la quincena seleccionada o todo el ejercicio.</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="display: flex; justify-content: center;" >
            <v-btn small text color="primary" @click="downloadPeriodo('quincena')">
              Quincena
            </v-btn>
            <v-btn small text color="primary" @click="downloadPeriodo('ejercicio')">
              Ejercicio
            </v-btn>
            <v-btn small text color="primary" @click="showDlgDownload= false">
              Cancelar
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu :value="verMotivo" :position-x="posX" :position-y="posY">
      <v-card width="400" flat>
        <v-card-text class="pa-2">
            <span class="font-weight-medium">{{mensajeMotivo}}</span>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import axios from "axios";
  import MovsJusti from '@/views/public/rh/MovsJusti.vue';
  import DialogMessage from "@/components/dialogs/DialogMessage.vue";
  import BuscarEmpleado from '@/components/dialogs/BuscarEmpleado.vue';
  import AccesosUtils from "@/utils/AccesosUtils.js";

  export default {
    components: {
      MovsJusti,
      DialogMessage,
      BuscarEmpleado
    },
    data() {
      return {
        APLICADO: 4,
        loading: false,
        justificantes: [],
        selected: [],
        headerJusti: [
          { text: 'Nombre', value: 'nombre', class: "accent white--text"},
          { text: 'Justificante', value: 'justificante', class: "accent white--text"},
          { text: 'Periodo', value: 'vigenciaIni', class: "accent white--text"},
          //{ text: 'Al', value: 'vigenciaFin', class: "accent white--text"},
          { text: 'Dias', value: 'dias', class: "accent white--text"},
          { text: 'Devueltos', value: 'diasRecuperados', class: "accent white--text"},
          { text: 'Estatus', value: 'estatus', class: "accent white--text"},
          { text: 'Bandeja', value: 'nomEnviado', class: "accent white--text"},
          { text: 'Ver', value: 'actions', class: "accent white--text"},
        ],
        footerProps: {
          disableItemsPerPage: true,
        },
        overlay: false,
        showBtnSave: true,
        motivo: null,
        rulesMotivo: [v => (!v || v.length <= 300) || 'Máximo 300 caracteres'],
        labelMotivo: "",
        showDlgMotivo: false,
        showDlgDownload: false,
        posX: 0,
        posY: 0,
        verMotivo: false,
        mensajeMotivo: '',
        empledoJustificante: "",
        filterItems: [],
        tipoJus: "",
        accesosUtils: new AccesosUtils(),
        justiUtil: null,
        empSearch: null,
        uniEje: null,
        coordEst: null,
        ambito: null,
        ejercicio: null,
        quincena: null,
        unidades: [],
        coordsEst: [],
        ambitos: [],
        ejercicios: [],
        quincenas: [],
        showMovs: false,
        movsJusti: [],
        inicializado: false,
        observer: false,
        mensaje: '',
        showDlg: false,
        colorDlg: 'primary',
        titleDlg: '',
        modoEmpleado: false
      }
    },
    computed: {
      ...mapState(['usuario', 'baseContexto']),
      hideFooterJusti() {
        return this.justificantes.length < 10;
      },
      disabledOkMotivo() {
        let ok = (this.motivo && this.motivo.trim().length > 0 && this.motivo.trim().length <= 300);
        return !ok;
      },
      hasAccesAplicar() {
        return this.usuario.opcionesAcceso.includes('APLICAR_JUSTIFICANTE');
      },
      //...mapState(['usuario'])
    },
    watch: {
      empSearch() {
        if (this.empSearch) {
          this.loadJustiEmpleado();
        }
      },
      uniEje() {
        if (this.inicializado && this.uniEje && this.observer) {
          this.updateAmbitos();
        }
      },
      ambito() {
        if (this.inicializado && this.observer) {
          this.updateCoordEst();
        }
      }
    },
    methods: {
      async loadJustificantes() {
        this.loading = true;
        this.modoEmpleado = false;
        const self = this;
        const ue = this.uniEje;
        const ce = this.coordEst;
        const amb = this.ambito;
        const qna = this.ejercicio+ "-"+ this.quincena;
        try {
          const response = await axios.get(`/justificante/sinautorizar/${ue}/${ce}/${amb}?qna=${qna}`)
          self.justificantes = response.data;
        }
        catch(error) {
          if (error.response) {
            console.log(error.response);
            self.showError(error.response.data);
          } else {
            console.log(error);
            self.showError("Error en la petición.");
          }
        }
        finally {
          self.loading = false;
        }
      },

      loadJustiEmpleado() {
        this.selected = [];
        this.modoEmpleado = true;
        this.loading = true;
        const self = this;
        axios.get(`/justificante/sinautorizar/${this.empSearch.numEmpleado}`)
        .then(response => {
          self.justificantes = response.data;
        })
        .catch(error => {
          if (error.response) {
            self.showError(error.response.data);
          } else {
            self.showError("Error en la petición");
          }
        })
        .finally(() => {
          self.loading = false;
        });
      },

      loadMovimientosJusti(justi) {
        let self = this;
        axios.get(`/justificante/movimientos/${justi.idJustificante}`)
        .then(response => {
          self.movsJusti = response.data;
          self.empledoJustificante = justi.nombre;
          let del = self.formatFec(justi.vigenciaIni);
          let al = self.formatFec(justi.vigenciaFin);
          if (del === al) {
            self.tipoJus = justi.justificante+ " del "+ del
          } else {
            self.tipoJus = justi.justificante+ " del "+ del+ " al "+ al
          }
          self.showMovs = true;
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response);
            self.showError(error.response.data);
          } else {
            console.log(error);
            self.showError("Error en la petición.");
          }
        });
      },

      onSelectAllJus() {
        // Do nothing
      },

      validaJustificantes() {
        this.showDlgMotivo = false;
        const vacaciones = this.selected.some(ju => ju.tipoJustificante == 29);
        if (vacaciones) {
          this.showInfo('No se puede Aplicar justificantes de vacaciones.');
        } else {
          this.autorizarExtemporaneo();
        }
      },

      autorizarExtemporaneo() {
        if (this.selected.length > 0) {
          this.labelMotivo = "Motivo de autorización extemporanea";
          this.motivo = null;
          this.showBtnSave = true;
          this.showDlgMotivo = true;
        } else {
          this.showWarning("Debe seleccionar al menos un justificante.");
        }
      },

      saveUpdateJustificante() {
        this.showDlgMotivo = false;
        const aplicados = this.selected.map(ju => ({...ju, motivo: this.motivo, idEstatusJustificante: this.APLICADO}));
        this.motivo = null;
        let self = this;
        this.overlay = true;
        axios.put(`/justificante?modo=private`, aplicados)
        .then(response => {
          self.motivo = null;
          self.overlay = false;
          self.selected = [];
          self.showInfo(response.data);
          self.reload();
        })
        .catch(error => {
          self.overlay = false;
          self.motivo = null;
          if (error.response) {
            self.showInfo(error.response.data);
            self.reload();
          } else {
            self.showError("Error en la petición");
          }
        });
      },

      async loadTiposJustificantes() {
        let self = this;
        try {
          const response = await axios.get(`/justificante/tipos?modo=private`);
          let tipos = response.data;
          self.filterItems = tipos.map(e => {
            let  tj = {tipoJustificante: e.tipoJustificante, descripcion: e.descripcion};
            return tj;
          });
        } catch(error) {
          console.log(error);
        }
      },

      reload() {
        this.empSearch = null;
        this.loadJustificantes();
      },

      async loadAccesos() {
        let self = this;
        await this.accesosUtils.loadAccesos(this.usuario, (unidades, ambitos, ces) => {
          self.observer = false;
          self.unidades = unidades;
          self.ambitos = ambitos;
          self.coordsEst = ces;
          self.observer = true;
        });
      },

      haveMotivo(justificante) {
        let hay = justificante.motivo && justificante.motivo.length > 0;
        return hay;
      },

      showMotivo(event, mensaje) {
        if (!this.verMotivo) {
          this.posX = event.clientX+ 30;
          this.posY = event.clientY;
          this.mensajeMotivo = mensaje;
          this.verMotivo = true;
        }
      },

      hideMotivo() {
        if (this.verMotivo) {
          this.mensajeMotivo = null;
          this.verMotivo = false;
        }
      },

      updateAmbitos() {
        let self = this;
        this.accesosUtils.loadAccesosUniEje(this.uniEje, (ambitos, ces) => {
          self.observer = false;
          self.ambitos = ambitos;
          if (ambitos && ambitos.length > 0) {
            self.ambito = ambitos[0].value;
          }
          self.coordsEst = ces;
          if (ces && ces.length > 0) {
            self.coordEst = ces[0].value;
          }
          self.observer = true;
        });
      },

      updateCoordEst() {
        let self = this;
        this.accesosUtils.loadAccesosAmb(this.uniEje, this.ambito, (ces) => {
          self.coordsEst = ces;
          if (ces && ces.length > 0) {
            self.coordEst = ces[0].value;
          }
        });
      },

      initEjercicios() {
        const year = new Date().getFullYear();
        for (let ejer = year; ejer >= 2021; ejer--) {
          this.ejercicios.push({texto: ejer, value: ejer});
        }
        this.ejercicio = year;
      },

      initQuincenas() {
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        for (let i = 0; i < meses.length; i++) {
          const qna = (i+ 1)* 2;
          this.quincenas.push({texto: `1a ${meses[i]}`, value: qna- 1})
          this.quincenas.push({texto: `2a ${meses[i]}`, value: qna})
        }
        const hoy = new Date();
        const dia = hoy.getDate();
        const mes = hoy.getMonth();
        if (mes == 0) { // Enero
          if (dia > 15) {
            this.quincena = 1;
          } else {
            this.quincena = 24;
            this.ejercicio--;
          }
        } else {
          this.quincena = (mes+1)* 2;
          if (dia <= 15) {
            this.quincena--;
          }
          this.quincena--;
        }
      },

      nombreJustificante(item) {
        const {justificante, ejercicio, periodo} = item;
        const tipoJustificante = item.tipoJustificante;
        let nombre;
        if (tipoJustificante === 29) {
          let per = periodo === "Extra"? periodo: periodo+ "-"+ ejercicio.substr(2, 2);
          nombre = justificante+ " "+ per;
        } else {
          nombre = justificante;
        }
        return nombre;
      },

      makePeriodo(item) {
        const {vigenciaIni, vigenciaFin} = item;
        const [, month1, day1] = vigenciaIni.substr(0,10).split('-');
        const [, month2] = vigenciaFin.substr(0,10).split('-');
        let periodo;
        if (vigenciaIni === vigenciaFin) {
          periodo = this.formatFec(vigenciaIni);
        } else {
          if (month1 === month2) {
            periodo = day1+ " - "+ this.formatFec(vigenciaFin);
          } else {
            periodo = this.formatFec(vigenciaIni)+ " - "+ this.formatFec(vigenciaFin);
          }
        }
        return periodo;
      },

      formatFec(fecha) {
        if (!fecha) return ""
        const [year, month, day] = fecha.substr(0,10).split('-');
        return `${day}/${month}/${year}`
      },

      formatDias(item) {
        const incluye = [19,22,25,35,37].includes(item.tipoJustificante);
        if (item.dias && !incluye) 
          return item.dias;
        else 
          return "-";
      },

      async init() {
        this.initEjercicios();
        this.initQuincenas();
        this.uniEje = this.usuario.unidadEjecutora;
        this.ambito = this.usuario.ambito;
        this.coordEst = this.usuario.coordEstatal.toString();
        await this.loadJustificantes();
        await this.loadTiposJustificantes();
        await this.loadAccesos();
        this.showJustiEmp = false;
        this.inicializado = true;
      },

      doDownload() {
        if (this.modoEmpleado) {
          this.downloadempleado();
        } else {
          this.showDlgDownload = true;
        }
      },

      async downloadPeriodo(reporte) {
        this.showDlgDownload = false;
        this.overlay = true;
        const self = this;
        const ue = this.uniEje;
        const ce = this.coordEst;
        const amb = this.ambito;
        const qna = this.ejercicio+ "-"+ (reporte === 'quincena'? this.quincena: '0' );
        try {
          const response = await axios.get(`/justificante/sinautorizar/download/${ue}/${ce}/${amb}?qna=${qna}`)
          const servlet = response.data;
          const url = self.baseContexto+ servlet;
          location.href = url; // Descargar el archivo
        }
        catch(error) {
          if (error.response) {
            console.log(error.response);
            self.showError(error.response.data);
          } else {
            console.log(error);
            self.showError("Error en la petición.");
          }
        }
        finally {
          self.overlay = false;
        }
      },

      async downloadempleado() {
        this.overlay = true;
        const self = this;
        try {
          const numEmpleado = this.empSearch.numEmpleado;
          const response = await axios.get(`/justificante/sinautorizar/download/${numEmpleado}`)
          const servlet = response.data;
          const url = self.baseContexto+ servlet;
          location.href = url; // Descargar el archivo
        }
        catch(error) {
          if (error.response) {
            console.log(error.response);
            self.showError(error.response.data);
          } else {
            console.log(error);
            self.showError("Error en la petición.");
          }
        }
        finally {
          self.overlay = false;
        }
      },

      showError: function (message) {
        this.mensaje = message;
        this.colorDlg = "error";
        this.titleDlg = "Error",
        this.showDlg = true;
      },

      showWarning: function (message) {
        this.mensaje = message;
        this.colorDlg = "accent";
        this.titleDlg = "Revisar",
        this.showDlg = true;
      },
      
      showInfo: function (message) {
        this.mensaje = message;
        this.colorDlg = "primary";
        this.titleDlg = "Aviso",
        this.showDlg = true;
      },
    },
    mounted() {
      this.init();
    }
  }
</script>

<style scoped>
  .v-data-table-header tr th {
    background-color: #82b1ff !important;
    border-color: #82b1ff !important;
  }

  .width-find {
    width: 100%;
  }

  .align-dlg-motivo {
    align-self: flex-end;
  }

  .fix-div {
    position: absolute;
    top: 100px;

  }
</style>
